module.exports = __webpack_public_path__ + "237d6d5a55ceef492fba8ac6321c7ce4.svg";


//////////////////
// WEBPACK FOOTER
// ./images/red-warning-circle-icon.svg
// module id = 1102
// module chunks = 0